var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.resultCount > 0
    ? _c(
        "div",
        _vm._l(_vm.tokens, function(token) {
          return _c("span", { staticClass: "my-search-token" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeToken(token)
                  }
                }
              },
              [_vm._v("×")]
            ),
            _vm._v("\n          " + _vm._s(token.label)),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: token.label && token.value && token.value != 3149,
                    expression:
                      "token.label && token.value && token.value != 3149"
                  }
                ]
              },
              [_vm._v(": " + _vm._s(token.value))]
            )
          ])
        }),
        0
      )
    : _c(
        "div",
        _vm._l(_vm.tokens, function(token) {
          return _c(
            "span",
            { staticClass: "my-search-token no-search-record" },
            [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.closeToken(token)
                    }
                  }
                },
                [_vm._v("×")]
              ),
              _vm._v("\n\t\t\t\t" + _vm._s(token.label)),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: token.label && token.value && token.value != 3149,
                      expression:
                        "token.label && token.value && token.value != 3149"
                    }
                  ]
                },
                [_vm._v(": " + _vm._s(token.value))]
              )
            ]
          )
        }),
        0
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }